type CareChevronLeftIconProps = {
  size?: number;
};

/** 24×24 back chevron for Care treatment detail (matches Figma). */
export const CareChevronLeftIcon = ({ size = 24 }: CareChevronLeftIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M15 18L9 12L15 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
